<template>
    <div class="info-modal hide">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <div class="basic-content">
                <h2>SKAMP<sup>1</sup></h2>

                <p><b>The SKAMP scale assesses behaviors critical to success in school settings.</b> The SKAMP uses 13
                    items
                    (attentiveness, quality of work, compliance, etc) to assess behaviors in classroom settings, rated
                    by a
                    trained observer, using a 7-point scale to rate the level of severity with each item. </p>

                <p><b style="color:#30368C">0 = Normal (no impairment)<br />
                        1 = Slight impairment<br />
                        2 = Mild impairment<br />
                        3 = Moderate impairment<br />
                        4 = Severe impairment<br />
                        5 = Very severe impairment<br />
                        6 = Maximal impairment
                    </b>
                </p>



            </div>

            <div class="refs">
                <p><b>References: 1.</b> Wigal SB, Gupta S, Guinta D, Swanson JM. Reliability and validity of the SKAMP
                    rating scale in a laboratory school setting. <i>Psychopharmacol Bull</i>.
                    1998;34(1):47-53.</p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>
<style lang="scss" scoped>
.info-modal-content .basic-content {
    padding-right: 50px;
}

.info-modal-content {
    p {
        font-size: 20px;
        line-height: 1.2;
    }
}
</style>